<mat-card
  id="procedures-card"
  class="has-progress-bar"
  [ngClass]="{
    'card-table': products?.length > 0,
    default: products == null || products?.length === 0
  }"
>
  <mat-progress-bar [mode]="appointment == null ? 'determinate' : 'determinate'"></mat-progress-bar>
  <mat-card-title
    *appHasPermission="'appointment.edit'"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <span>{{ 'procedures-card.title' | translate }}</span>
  </mat-card-title>

  <mat-card-content *ngIf="products == null" fxLayout="column">
    {{ 'common.loading' | translate }}…
  </mat-card-content>

  <mat-card-content *ngIf="products?.length === 0" fxLayout="column">
    <p>
      {{ 'procedures-card.no-procedures' | translate }}
    </p>
  </mat-card-content>

  <mat-card-content *ngIf="products?.length > 0 && transformedStudies?.length > 0" fxLayout="column">
    <table mat-table [dataSource]="transformedStudies">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'procedures-card.table.procedure' | translate }}
        </th>
        <td mat-cell *matCellDef="let study">
          <ng-container *ngIf="editable; else noEditPermission">
            <button *appHasPermission="'setting.edit'; else noEditPermission"
              mat-flat-button
              [matTooltip]="'procedures-card.table.procedure-action' | translate"
              (click)="openEditProduct(study)">
              {{ study.productName }}
            </button>
          </ng-container>
          <ng-template #noEditPermission>
            {{ study.productName }}
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="eid">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'procedures-card.table.eid' | translate }}
        </th>
        <td mat-cell *matCellDef="let study">
          {{ study.eid }}
        </td>
      </ng-container>

      <ng-container matColumnDef="procedureCodes">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'procedures-card.table.procedureCodes' | translate }}
        </th>
        <td mat-cell *matCellDef="let study">
          {{ study.productCodes?.join(', ') }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diagnosisCodes">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'procedures-card.table.diagnosisCodes' | translate }}
        </th>
        <td mat-cell *matCellDef="let study">
          {{ study.getDiagnosisCodesNames()}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card-content>
</mat-card>
